import React from 'react'

import { PromotionListContainerStyled, PromotionListStyled, PromotionListItemStyled } from './styles'
import PromotionBox from './../../molecules/PromotionBox'
import { PromotionListProps } from './types'

const PromotionList: React.FC<PromotionListProps> = ({ data }) => {
  return (
    <PromotionListContainerStyled>
      <PromotionListStyled as="ul">
        {data.map((el, { key }) => (
          <PromotionListItemStyled as="li" {...{ key }}>
            <PromotionBox data={el} />
          </PromotionListItemStyled>
        ))}
      </PromotionListStyled>
    </PromotionListContainerStyled>
  )
}

export default PromotionList
